<template>

  <div>

    <UpdateAddressDialog v-if="!!user" v-model="showUpdateAddressDialog" :current-address="getAddress()"></UpdateAddressDialog>
    <ChangePasswordDialog v-model="showChangePasswordDialog"></ChangePasswordDialog>

    <v-card color="white" class="card-border">
      <v-system-bar height="45" window color="itoviGrayLight">
        <h2 class="card-header-text">Your Account</h2>
        <v-spacer></v-spacer>
      </v-system-bar>


      <div v-if="!(!!user)" class="pa-4">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
      <div v-if="!!user" class="card-body">

        <!-- Billing Address               -->
        <v-layout align-center row wrap>
          <span class="txt-bold">Billing Address</span>
          <v-spacer></v-spacer>
          <v-btn small flat color="accent" class="txt-bold"
                 @click="showUpdateAddressDialog = true">Update
          </v-btn>
        </v-layout>

        <div>{{ user.name }}</div>
        <div>{{ getAddress().primary }}</div>
        <div v-if="getAddress().secondary">{{ getAddress().secondary }}</div>
        <div v-if="!!getAddress().city || !!getAddress().state">
          <span>{{ getAddress().city }}, {{ getAddress().state }} {{ getAddress().postal_code }}</span>
        </div>

        <v-divider class="mt-4 mb-3"></v-divider>

        <div class="txt-bold">Email</div>
        <div class="pt-1">{{ user.email }}</div>

        <v-divider class="mt-4 mb-3"></v-divider>

        <v-layout align-center row wrap>
          <span class="txt-bold">Password</span>
          <v-spacer></v-spacer>
          <v-btn small flat color="accent" class="txt-bold"
                 @click="showChangePasswordDialog=true">Change
          </v-btn>
        </v-layout>
        <div>********</div>

      </div>

    </v-card>
  </div>

</template>

<script>
  import api from "../../../services/api_endpoints";
  import store from '../../../store'
  import UpdateAddressDialog from './UpdateAddressDialog'
  import ChangePasswordDialog from './ChangePasswordDialog'
  import subscribeToStore from "@/mixins/subscribeToStore"

  export default {
    components: {
      UpdateAddressDialog,
      ChangePasswordDialog,
    },
    data: ()=> ({
      user: store.state.user,
      showUpdateAddressDialog: false,
      showChangePasswordDialog: false,
    }),
    props: {
      onLoaded: Function,
    },
    mixins: [subscribeToStore],
    created(){
      this.fetchData()
    },
    mounted() {
      this.subscribeToStore(['user'])
    },
    methods: {
      getAddress() {
        // if (Array.isArray(this.user.address.billing) && this.user.address.billing.length === 0) {
        //   return this.user.address.shipping
        // }
        return this.user.address.billing
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchData() {
        await api.getUser();
        if (this.isFunction(this.onLoaded)) this.onLoaded()
      },
    },
  }
</script>
